module.exports = __webpack_public_path__ + "9cbb74f0ed96b5a0725df913dabbc370.png";